import api from './api';
import {formatPhoneNumber} from './formatHelpers';
import isMobile from 'ismobilejs';
import {getCookie} from '../../reactModules/shared/utilities/cookies';

export const getPlanningAttributes = () => {
  const planningCookie = getCookie('_leg_LG');

  if (planningCookie) {
    const jsonPlanningCookie = JSON.parse(decodeURIComponent(planningCookie));
    const cleanedPlanningCookie = jsonPlanningCookie.map(attribute => ({
      [attribute.name]: attribute.a,
    }));
    const combinedAttributes = {};

    cleanedPlanningCookie.forEach(attribute =>
      Object.assign(combinedAttributes, attribute)
    );
    return combinedAttributes;
  }
  return {};
};

export const sendToWebcollect = payload => {
  return api.post('/funeral-homes/sf/webcollect', payload);
};

const determineDevice = () => {
  if (isMobile.phone) {
    return 'Phone';
  }
  if (isMobile.tablet) {
    return 'Tablet';
  }
  return 'Desktop';
};

export const buildSalesforcePayload = ({
  form = 'helpPlanning',
  formValues,
  funeralHome = {},
  affiliate = {},
}) => {
  const planningAttributes = getPlanningAttributes();
  const {firstName, lastName, phoneNumber, email} = formValues;
  let {zipCode} = formValues;
  const formattedPhoneNumber = formatPhoneNumber(phoneNumber) || phoneNumber;

  const keys = {
    ContactEmail: email,
  };

  if (form === 'helpPlanning') {
    keys.FHID = funeralHome.funeralHomeId;
  }

  if (!zipCode && funeralHome && funeralHome.location) {
    zipCode = funeralHome.location.postalCode;
  }

  const values = {
    ContactFirstName: firstName,
    ContactLastName: lastName,
    ContactPhoneNumber: formattedPhoneNumber,
    ContactZip: zipCode || null,
    FuneralHomeName: funeralHome.name || null,
    FuneralHomeAddress: funeralHome.profileData
      ? funeralHome.profileData.address1
      : null,
    FuneralHomeZip: funeralHome.location
      ? funeralHome.location.postalCode
      : null,
    ImmediateNeedOrPreNeed: planningAttributes.q_preneed || null,
    PlanningFor: planningAttributes.q_who || null,
    Religion: planningAttributes.q_religion || null,
    ServiceType: planningAttributes.q_traditional || null,
    Budget: planningAttributes.q_budget || null,
    ServicePreferences: planningAttributes.q_body || null,
    SiteName: affiliate.description || 'Legacy',
    DevicesSource: determineDevice(),
  };

  if (form === 'planningGuide') {
    values.FHID = funeralHome.funeralHomeId;
  }

  return [
    {
      keys,
      values,
    },
  ];
};



// WEBPACK FOOTER //
// ./src/appModules/utilities/salesforceApi.js